import styles from "./index.module.scss";
import { logout } from "../../firebase/auth";
import { useSelector } from "react-redux";
import { ScreenType, useHomeContext } from "../../contexts/HomeContextProvider";
import { brandLogo } from "../../Constants/AssetConstant";
// import { Avatar, Flex, Popover } from "antd";
// import { MenuOutlined } from "@ant-design/icons";
// import { getInitials } from "../../utils";

const NavHeader = () => {
  const { updateMultipleState, state } = useHomeContext();
  const user = useSelector((state) => state.user);

  const redirectToHome = () => {
    updateMultipleState({
      screen: ScreenType.TEMPLATE_SCREEN,
      formDetails: { ...state.formDetails, templateId: "" },
    });
  };

  const handleLogout = () => {
    logout();
  };

  return (
    <div className={`${styles.wrapper}`}>
      <div className={styles.brandContainer}>
        <img src={brandLogo} alt="Docflix" />

        {/* {state.screen !== ScreenType.DASHBOARD_SCREEN && (
          <div className={styles.breadcrumbContainer}>
            <BreadcrumbComponent redirectToHome={redirectToHome} />
          </div>
        )} */}
      </div>
      {user && (
        <div
          className={`cursor-pointer btn ${styles.dashboardBtn}`}
          onClick={handleLogout}
        >
          LOGOUT
        </div>
      )}

      {/* <Flex align="center" gap={"0 1rem"}>
        {user && (
          <Popover
            content={
              <div className={styles.profileContainer}>
                <div className={styles.userDetail}>
                  <p className={styles.name}>{user?.displayName || state?.formDetails?.name}</p>
                  <p className={styles.hq}>{state.formDetails?.hq}</p>
                </div>

                <button
                  onClick={handleLogout}
                  className={`btn ${styles.logoutBtn}`}
                >
                  Logout
                </button>
              </div>
            }
            // title="User Details"
            trigger="hover"
            className={`cursor-pointer ${styles.right}`}
          >
            <Avatar size={"large"} className={styles.avatar}>
              {getInitials(user?.displayName || state?.formDetails?.name || "NA")}
            </Avatar>
          </Popover>
        )}
        {state.screen !== ScreenType.DASHBOARD_SCREEN && (
          <Popover
            content={
              <div className={styles.hamburgerContainer}>
                <BreadcrumbComponent redirectToHome={redirectToHome} />
              </div>
            }
            // title="User Details"
            trigger="click"
            className={`cursor-pointer ${styles.hamburgerContainer}`}
          >
            <MenuOutlined className={styles.hamburger} />
          </Popover>
        )}
      </Flex> */}
    </div>
  );
};

export default NavHeader;

export const BreadcrumbComponent = ({ redirectToHome }) => {
  const { updateScreen, state } = useHomeContext();

  return (
    <div className={styles.breadcrumb}>
      <div
        className={`cursor-pointer ${styles.crumb} ${
          state.screen === ScreenType.TEMPLATE_SCREEN ? styles.active : ""
        }`}
        onClick={redirectToHome}
      >
        Home
      </div>
      <span>&gt;</span>
      <div
        className={`cursor-pointer ${styles.crumb} ${
          state.screen === ScreenType.FORM_SCREEN ? styles.active : ""
        }`}
        onClick={() => {
          updateScreen(ScreenType.FORM_SCREEN);
        }}
      >
        Generate video
      </div>
      {state.screen !== ScreenType.FORM_SCREEN && (
        <>
          <span>&gt;</span>
          <div
            className={`cursor-pointer ${styles.crumb} ${
              state.screen === ScreenType.TEMPLATE_SCREEN ? styles.active : ""
            }`}
            onClick={() => {
              updateScreen(ScreenType.TEMPLATE_SCREEN);
            }}
          >
            Select templates
          </div>
        </>
      )}
    </div>
  );
};
